/* Hondeland — chat-bubbel. Praat met de hondeland-chat server (chat-server/). */
(function () {
  'use strict';
  var cfg = window.HondelandChat;
  if (!cfg || !cfg.server || document.querySelector('.hl-chat')) return;

  var API = cfg.server.replace(/\/+$/, '') + '/api';
  var t = cfg.text || {};
  var KEY_TOKEN = 'hl_chat_token', KEY_SEEN = 'hl_chat_seen', KEY_CACHE = 'hl_chat_cache', KEY_MAIL = 'hl_chat_mail_skip';

  function store(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function load(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  /* Chatlink van een ander apparaat: ?hlchat=<token> */
  var openFromLink = false;
  try {
    var u = new URL(location.href);
    var linked = u.searchParams.get('hlchat');
    if (linked && /^[A-Za-z0-9_-]{20,64}$/.test(linked)) {
      if (linked !== load(KEY_TOKEN)) { store(KEY_CACHE, null); store(KEY_SEEN, null); }
      store(KEY_TOKEN, linked);
      openFromLink = true;
      u.searchParams.delete('hlchat');
      history.replaceState(null, '', u.pathname + u.search + u.hash);
    }
  } catch (e) {}

  var state = {
    token: load(KEY_TOKEN),
    email: null,
    messages: [],
    open: false,
    timer: null,
    idleSince: Date.now(),
    sending: false
  };
  try { state.messages = JSON.parse(load(KEY_CACHE) || '[]') || []; } catch (e) { state.messages = []; }

  function newToken() {
    var a = new Uint8Array(24);
    (window.crypto || window.msCrypto).getRandomValues(a);
    return btoa(String.fromCharCode.apply(null, a)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function identity() {
    var o = {};
    if (state.token) o.token = state.token;
    if (cfg.customer && cfg.customer.id && cfg.customer.sig) { o.customerId = cfg.customer.id; o.sig = cfg.customer.sig; }
    return o;
  }
  function hasIdentity() { var i = identity(); return !!(i.token || i.customerId); }

  function api(method, path, data) {
    var url = API + path;
    var opts = { method: method, headers: {} };
    if (method === 'GET') url += '?' + new URLSearchParams(data).toString();
    else { opts.headers['content-type'] = 'application/json'; opts.body = JSON.stringify(data); }
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.error || 'Er ging iets mis');
        return j;
      });
    });
  }

  /* ---------- DOM ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  var ICON_CHAT = '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path fill="currentColor" d="M12 3C6.5 3 2 6.9 2 11.7c0 2.4 1.1 4.6 3 6.2-.2 1.3-.8 2.6-1.8 3.6 2 0 3.8-.7 5.1-1.8 1.2.4 2.4.6 3.7.6 5.5 0 10-3.9 10-8.7S17.5 3 12 3Z"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M6 6l12 12M18 6 6 18"/></svg>';
  var ICON_SEND = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path fill="currentColor" d="M3.4 20.4 21 12 3.4 3.6 3.3 10l12.2 2-12.2 2z"/></svg>';
  var ICON_LINK = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/></svg>';

  var root = el('div', 'hl-chat');
  var bubble = el('button', 'hl-chat__bubble');
  bubble.type = 'button';
  bubble.setAttribute('aria-label', t.open || 'Open de chat');
  bubble.setAttribute('aria-expanded', 'false');
  bubble.innerHTML = ICON_CHAT;
  var badge = el('span', 'hl-chat__badge');
  badge.hidden = true;
  bubble.appendChild(badge);

  var panel = el('section', 'hl-chat__panel');
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', t.title || 'Chat');
  panel.hidden = true;

  var head = el('header', 'hl-chat__head');
  var headText = el('div', 'hl-chat__head-text');
  headText.appendChild(el('strong', 'hl-chat__title', t.title || 'Vragen? Chat met ons'));
  headText.appendChild(el('span', 'hl-chat__sub', t.subtitle || 'We antwoorden meestal binnen een uur'));
  var linkBtn = el('button', 'hl-chat__icon');
  linkBtn.type = 'button';
  linkBtn.title = t.copy_link || 'Kopieer chatlink (om later verder te gaan)';
  linkBtn.setAttribute('aria-label', linkBtn.title);
  linkBtn.innerHTML = ICON_LINK;
  linkBtn.hidden = true;
  var closeBtn = el('button', 'hl-chat__icon');
  closeBtn.type = 'button';
  closeBtn.setAttribute('aria-label', t.close || 'Sluiten');
  closeBtn.innerHTML = ICON_X;
  head.appendChild(headText);
  head.appendChild(linkBtn);
  head.appendChild(closeBtn);

  var list = el('div', 'hl-chat__list');
  list.setAttribute('aria-live', 'polite');

  var mailCard = el('form', 'hl-chat__mail');
  mailCard.hidden = true;
  mailCard.noValidate = true;
  mailCard.appendChild(el('p', null, t.email_prompt || 'Laat je e-mail achter, dan krijg je ook antwoord als je de site verlaat.'));
  var mailRow = el('div', 'hl-chat__mail-row');
  var mailInput = el('input');
  mailInput.type = 'email';
  mailInput.placeholder = t.email_placeholder || 'jij@voorbeeld.nl';
  mailInput.autocomplete = 'email';
  mailInput.setAttribute('aria-label', 'E-mail');
  var mailBtn = el('button', null, t.email_save || 'Opslaan');
  mailBtn.type = 'submit';
  var mailSkip = el('button', 'hl-chat__mail-skip', t.email_skip || 'Nee, dank je');
  mailSkip.type = 'button';
  mailRow.appendChild(mailInput);
  mailRow.appendChild(mailBtn);
  mailCard.appendChild(mailRow);
  mailCard.appendChild(mailSkip);

  var form = el('form', 'hl-chat__form');
  var input = el('textarea', 'hl-chat__input');
  input.rows = 1;
  input.maxLength = 2000;
  input.placeholder = t.placeholder || 'Typ je bericht\u2026';
  input.setAttribute('aria-label', input.placeholder);
  var sendBtn = el('button', 'hl-chat__send');
  sendBtn.type = 'submit';
  sendBtn.setAttribute('aria-label', t.send || 'Versturen');
  sendBtn.innerHTML = ICON_SEND;
  form.appendChild(input);
  form.appendChild(sendBtn);

  var note = el('p', 'hl-chat__note');
  note.hidden = true;

  panel.appendChild(head);
  panel.appendChild(list);
  panel.appendChild(note);
  panel.appendChild(mailCard);
  panel.appendChild(form);
  root.appendChild(panel);
  root.appendChild(bubble);
  document.body.appendChild(root);

  /* ---------- render ---------- */
  function fmtTime(ms) {
    var d = new Date(ms), today = new Date();
    var hm = d.toLocaleTimeString(document.documentElement.lang || 'nl', { hour: '2-digit', minute: '2-digit' });
    return d.toDateString() === today.toDateString() ? hm : d.toLocaleDateString(document.documentElement.lang || 'nl', { day: 'numeric', month: 'short' }) + ' ' + hm;
  }

  function render() {
    var nearBottom = list.scrollHeight - list.scrollTop - list.clientHeight < 80;
    list.textContent = '';
    var greet = el('div', 'hl-chat__msg hl-chat__msg--agent');
    greet.appendChild(el('div', 'hl-chat__text', t.greeting || 'Hoi! \ud83d\udc3e Waarmee kunnen we je helpen?'));
    list.appendChild(greet);
    state.messages.forEach(function (m) {
      var row = el('div', 'hl-chat__msg hl-chat__msg--' + (m.from === 'visitor' ? 'me' : 'agent') + (m.pending ? ' is-pending' : ''));
      row.appendChild(el('div', 'hl-chat__text', m.body));
      row.appendChild(el('time', 'hl-chat__time', m.pending ? '\u2026' : fmtTime(m.at)));
      list.appendChild(row);
    });
    if (nearBottom || state.forceScroll) { list.scrollTop = list.scrollHeight; state.forceScroll = false; }
    linkBtn.hidden = !state.token;
    var visitorSent = state.messages.some(function (m) { return m.from === 'visitor' && !m.pending; });
    mailCard.hidden = !(visitorSent && !state.email && !load(KEY_MAIL) && !(cfg.customer && cfg.customer.email));
  }

  function lastId() {
    for (var i = state.messages.length - 1; i >= 0; i--) if (state.messages[i].id) return state.messages[i].id;
    return 0;
  }

  function saveCache() {
    store(KEY_CACHE, JSON.stringify(state.messages.filter(function (m) { return m.id; }).slice(-100)));
  }

  function updateBadge() {
    var seen = parseInt(load(KEY_SEEN) || '0', 10);
    var n = state.messages.filter(function (m) { return m.from === 'agent' && m.id > seen; }).length;
    if (state.open) { n = 0; store(KEY_SEEN, String(lastId())); }
    badge.hidden = !n;
    badge.textContent = n > 9 ? '9+' : String(n);
    bubble.setAttribute('aria-label', (t.open || 'Open de chat') + (n ? ' (' + n + ')' : ''));
  }

  function merge(incoming) {
    var known = {};
    state.messages.forEach(function (m) { if (m.id) known[m.id] = true; });
    var added = false;
    incoming.forEach(function (m) { if (!known[m.id]) { state.messages.push(m); added = true; } });
    if (added) {
      var pending = state.messages.filter(function (m) { return !m.id; });
      state.messages = state.messages.filter(function (m) { return m.id; }).sort(function (a, b) { return a.id - b.id; }).concat(pending);
      saveCache();
    }
    return added;
  }

  /* ---------- sync ---------- */
  function fetchMessages(full) {
    if (!hasIdentity()) return Promise.resolve(false);
    var q = identity();
    q.after = full ? 0 : lastId();
    return api('GET', '/messages', q).then(function (res) {
      if (res.token && res.token !== state.token) { // b.v. ingelogde klant op nieuw apparaat
        if (state.token) state.messages = state.messages.filter(function (m) { return !m.id; });
        state.token = res.token;
        store(KEY_TOKEN, res.token);
      }
      if (res.email) state.email = res.email;
      if (full) {
        var pending = state.messages.filter(function (m) { return !m.id; });
        state.messages = pending;
      }
      var added = merge(res.messages || []);
      if (full) saveCache();
      if (added) state.idleSince = Date.now();
      render();
      updateBadge();
      return added;
    }).catch(function () { return false; });
  }

  function schedule() {
    clearTimeout(state.timer);
    if (document.hidden || !hasIdentity()) return;
    var idle = Date.now() - state.idleSince;
    var delay;
    if (state.open) delay = idle < 120000 ? 4000 : idle < 600000 ? 10000 : 30000;
    else if (lastActivity() > Date.now() - 30 * 60000) delay = 45000; // alleen als er recent gechat is
    else return;
    state.timer = setTimeout(function () { fetchMessages(false).then(schedule); }, delay);
  }

  function lastActivity() {
    var last = state.messages[state.messages.length - 1];
    return Math.max(last ? last.at || 0 : 0, state.idleSince);
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && hasIdentity()) fetchMessages(false).then(schedule);
    else clearTimeout(state.timer);
  });

  /* ---------- open / close ---------- */
  function setOpen(open) {
    state.open = open;
    panel.hidden = !open;
    root.classList.toggle('is-open', open);
    bubble.setAttribute('aria-expanded', String(open));
    bubble.innerHTML = open ? ICON_X : ICON_CHAT;
    bubble.appendChild(badge);
    if (open) {
      state.idleSince = Date.now();
      state.forceScroll = true;
      render();
      updateBadge();
      autosize();
      fetchMessages(false).then(schedule);
      if (window.matchMedia('(min-width: 750px)').matches) input.focus();
    } else {
      schedule();
    }
  }
  bubble.addEventListener('click', function () { setOpen(!state.open); });
  closeBtn.addEventListener('click', function () { setOpen(false); bubble.focus(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) { setOpen(false); bubble.focus(); } });
  /* elke knop met data-open-chat of href="#chat" opent de chat (ook knoppen die later laden) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-open-chat], a[href="#chat"]');
    if (!a) return;
    e.preventDefault();
    setOpen(true);
  });

  /* ---------- versturen ---------- */
  function autosize() { input.style.height = 'auto'; input.style.height = Math.min(input.scrollHeight, 120) + 'px'; }
  input.addEventListener('input', autosize);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : submit(e); }
  });

  function showNote(msg) {
    note.textContent = msg || '';
    note.hidden = !msg;
  }

  function submit(e) {
    if (e) e.preventDefault();
    var body = input.value.trim();
    if (!body || state.sending) return;
    if (!state.token && !(cfg.customer && cfg.customer.sig)) { state.token = newToken(); store(KEY_TOKEN, state.token); }
    var local = { from: 'visitor', body: body, at: Date.now(), pending: true };
    state.messages.push(local);
    state.forceScroll = true;
    input.value = '';
    autosize();
    showNote('');
    render();
    state.sending = true;
    var data = identity();
    data.body = body;
    data.page = (cfg.lang ? '[' + String(cfg.lang).toUpperCase() + '] ' : '') + location.href.split('#')[0];
    if (cfg.customer) { data.name = cfg.customer.name; data.email = cfg.customer.email; }
    api('POST', '/messages', data).then(function (res) {
      state.token = res.token;
      store(KEY_TOKEN, res.token);
      state.messages.splice(state.messages.indexOf(local), 1);
      merge([res.message]);
      state.idleSince = Date.now();
      render();
      updateBadge();
      schedule();
    }).catch(function (err) {
      input.value = body;
      autosize();
      showNote(err.message || t.error || 'Versturen mislukt, probeer het opnieuw.');
      state.messages.splice(state.messages.indexOf(local), 1);
      render();
    }).then(function () { state.sending = false; });
  }
  form.addEventListener('submit', submit);

  /* ---------- e-mail ---------- */
  mailCard.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = mailInput.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { mailInput.focus(); mailInput.setAttribute('aria-invalid', 'true'); return; }
    mailInput.removeAttribute('aria-invalid');
    var data = identity();
    data.email = email;
    mailBtn.disabled = true;
    api('POST', '/profile', data).then(function () {
      state.email = email;
      render();
      showNote(t.email_thanks || 'Top, we mailen je als je niet meer online bent.');
      setTimeout(function () { showNote(''); }, 5000);
    }).catch(function (err) { showNote(err.message); }).then(function () { mailBtn.disabled = false; });
  });
  mailSkip.addEventListener('click', function () { store(KEY_MAIL, '1'); render(); });

  /* ---------- chatlink kopiëren ---------- */
  linkBtn.addEventListener('click', function () {
    if (!state.token) return;
    var u = new URL(location.origin + '/');
    u.searchParams.set('hlchat', state.token);
    var done = function () { showNote(t.link_copied || 'Chatlink gekopieerd! Open hem op een ander apparaat om verder te chatten.'); setTimeout(function () { showNote(''); }, 6000); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(u.toString()).then(done, function () { window.prompt('Kopieer je chatlink:', u.toString()); });
    else window.prompt('Kopieer je chatlink:', u.toString());
  });

  /* ---------- start ---------- */
  render();
  updateBadge();
  if (hasIdentity()) fetchMessages(true).then(schedule);
  if (openFromLink) setOpen(true);
})();
